const api = {
  API_URL:
    process.env.NODE_ENV === "production"
      ? "/api"
      : process.env.REACT_APP_API_URL || "http://localhost:4000/api",
};

export { api };
